import type { AnyAction } from "redux";

import type { RootState } from "../RootState";

export interface WelcomeState {
	playgroundModal: boolean;
}

export const initialWelcomeState: WelcomeState = {
	playgroundModal: false,
};

const OPEN_PLAYGROUND_MODAL = "@welcome/PLAYGROUND_MODAL";

export const playgroundModal = ((payload) => ({ type: OPEN_PLAYGROUND_MODAL, payload })) satisfies (payload: {
	open: boolean;
}) => AnyAction;

export const WelcomeReducer = (
	state = initialWelcomeState,
	action: ReturnType<typeof playgroundModal>,
): WelcomeState => {
	switch (action.type) {
		case OPEN_PLAYGROUND_MODAL: {
			return {
				...state,
				playgroundModal: action.payload.open,
			};
		}

		default: {
			return state;
		}
	}
};

export const selectPlayGroundModal = (state: RootState) => state.pages.welcome.playgroundModal;
